import TripsMini from "icons/tripsMini.svg";
import WalletMini from "icons/wallet.svg";
import ProfileMini from "icons/profileMini.svg";
import SettingsMini from "icons/settings.svg";
import ShortcutsMini from "icons/shortcutsMini.svg";
import TravellersMini from "icons/travellersMini.svg";
import Expressway from "icons/expressway.svg";
import Ticket from "icons/ticket.svg";
import ChangeFlight from "icons/changeFlight.svg";
import Cancellations from "icons/cancellations.svg";
import { getCookie } from "src/utils/browserHelpers";

import BusPassAccounts from "icons/busPassAccounts.svg";
export const homePageNavItems = [
  {
    title: "Home",
    icon: "home",
    selected: false,
    url: "/",
    enable: getCookie("desktopUHP") === "true",
  },
  {
    title: "Flights",
    icon: "flights",
    selected: false,
    url: "/flights",
    enable: true,
  },
  {
    title: "Hotels",
    icon: "hotels",
    selected: false,
    url: "/hotels",
    enable: true,
  },
  { title: "Bus", icon: "bus", selected: true, url: "/bus", enable: true },
  {
    title: "Offers",
    icon: "offer",
    selected: false,
    url: "/offers/india",
    target: "_blank",
    enable: true,
  },
  {
    title: "My Trips",
    icon: "myTrips",
    selected: false,
    url: "/support",
    target: "_blank",
    enable: true,
  },
  {
    title: "Support",
    icon: "support",
    selected: false,
    url: "/support",
    target: "_blank",
    enable: true,
  },
];

export const footerMainLinks = [
  {
    title: "About us",
    url: "/about",
  },
  {
    title: "Careers",
    url: "/jobs",
  },
  {
    title: "FAQs",
    url: "/faq",
  },
  {
    title: "Support",
    url: "/support",
  },
  {
    title: "Cleartrip for work ",
    url: "https://www.cleartripforbusiness.com",
  },
  {
    title: "Gift cards",
    url: "https://www.cleartrip.com/lp/giftcards/",
  },
];
export const loginBannerImages = [
  {
    url: "https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt-prod/offermgmt/images/slider2.png",
    backgroundColor: "#FFEEE8",
  },
  {
    url: "https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt-prod/offermgmt/images/slider3.png",
    backgroundColor: "#FFEEE8",
  },
];
export const loginBannerImagesBeforeEvent = [
  {
    url: "https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt-prod/offermgmt/images/banner/novac-april-26-desktop-date-1.png",
    backgroundColor: "#EE5528",
  },
  {
    url: "https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt-prod/offermgmt/images/banner/novac-april-26-desktop-date-2.png",
    backgroundColor: "#1769EC",
  },
];

export const loginBannerImagesDuringEvent = [
  {
    url: `https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_BUS_DT1.png`,
    backgroundColor: '#3D1A6E',
  },
  {
    url: `https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_BUS_DT2.png`,
    backgroundColor: '#F4C6D7',
  },
];
export const bbdLogoStart =
  "https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_2025_LOGOstarts_22nd_sept.png";
export const bbdLogoEnd =
  "https://rukmini-ct.flixcart.com/f_auto,q_auto/offermgmt-prod/offermgmt/images/banner/BBD_2025_LOGOstarts_22nd_to_2ndOct-1.png";

export const loginHelpText =
  "We no more support email based login. You can now login via mobile number & link email to access your account.";

export const errorConfig = {
  ERROR_IN_SENDING_SMS: "Failed to send SMS OTP. Please try again.",
  OTP_SEND_LIMIT_EXCEEDED:
    "You exceeded the OTP limit. Please try again after 10 minutes.",
  ERROR_IN_SENDING_EMAIL: "Failed to send email OTP. Please try again.",
  NO_SAVED_OTP_FOUND: "OTP expired. Please resend OTP and try again.",
  INVALID_OTP: "Please enter a valid OTP",
  OTP_VALIDATE_LIMIT_EXCEEDED:
    "You exceeded the OTP validation limit. Please try again in 10 minutes.",
  INVALID_MOBILE: "Something went wrong. Please try again.",
  DEFAULT: "Something went wrong. Please try again.",
};

export const OTP_ERRORS = Object.keys(errorConfig);

export const MOBILE_COUNTRY_CODES = [
  { name: "India", code: "91", min: 10, max: 10 },
];

export const LOGIN_BANNER_URL =
  "https://rukmini-ct.flixcart.com/f_auto,q_auto,w_410,h_437,dpr_2/offermgmt-prod/offermgmt/bbdJson/Desktop_Banner.png";

export const accoutOptions = [
  {
    text: "Trips",
    link: "/accounts/trips",
    icon: TripsMini,
    actionName: "your_trips_trips",
  },
  {
    text: "Shortlists",
    link: "/account/shortlists",
    icon: ShortcutsMini,
    actionName: "your_trips_shortlists",
  },
  {
    text: "Travellers",
    link: "/account/travellers",
    icon: TravellersMini,
    actionName: "your_trips_travellers",
  },
  {
    text: "Cleartrip Wallet",
    link: "/accounts/wallet",
    icon: WalletMini,
    actionName: "your_trips_wallet",
  },
  {
    text: "Bus Pass",
    link: "/accounts/bus-pass",
    icon: BusPassAccounts,
    actionName: "your_bus_pass",
  },
  {
    text: "Expressway",
    link: "/accounts/expressway",
    icon: Expressway,
    actionName: "your_trips_expressway",
  },
  {
    text: "Profile",
    link: "/accounts/profile",
    icon: ProfileMini,
    actionName: "your_trips_profile",
  },
  {
    text: "Settings",
    link: "/account/settings",
    icon: SettingsMini,
    actionName: "",
  },
];
export const tools = [
  {
    text: "Cancellations",
    link: "/accounts/trips",
    icon: Cancellations,
    actionName: "your_trips_cancellations",
  },
  {
    text: "Change flight",
    link: "/accounts/trips",
    icon: ChangeFlight,
    actionName: "your_trips_change_flights",
  },
  {
    text: "Print ticket",
    link: "/accounts/trips",
    icon: Ticket,
    actionName: "your_trips_print_ticket",
  },
  {
    text: "Print hotel voucher",
    link: "/vouchers",
    icon: Ticket,
    actionName: "your_trips_hotel_voucher",
  },
];
